/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useSelectWithDescriptionStyles = makeStyles(() => ({
  select: {
    color: '#41404A',
    background: 'transparent',
    font: 'inherit',
    boxSizing: 'border-box',
    '& .MuiSelect-select': {
      padding: '6px 0 6px',
    },
    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
}));
